import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Confirmation.css';
import { getDatabase, ref, remove , get} from 'firebase/database';
import { app } from '../firbase';
import sendEmail from './emailjs_script';



const Confirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, phone, startTime, endTime, date } = location.state || {};

  const db = getDatabase(app);

  const handleEdit = () => {
    navigate('/editbooking', { state: location.state });
  };

  const handleHomePage = () => {
    navigate('/', { state: location.state });
  };

  // const handleCancel = () => {
  //   if (!name || !phone) {
  //       alert('Missing booking info!');
  //       return;
  //     }
  
  //     const bookingRef = ref(db, 'bookings/' + phone);
  //     remove(bookingRef)
  //       .then(() => {
  //         alert('Booking cancelled successfully!');
         
  //         navigate('/');
  //       })
  //       .catch((error) => {
  //         alert('Failed to cancel booking: ' + error.message);
  //       });
  // };

  const handleCancel = () => {
    if (!name || !phone) {
      alert('Missing booking info!');
      return;
    }
  
    const bookingRef = ref(db, 'bookings/' + phone);
  
    // Step 1: Fetch booking data before removing
    get(bookingRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const bookingData = snapshot.val();
  
          // Step 2: Remove booking
          remove(bookingRef)
            .then(() => {
              alert('Booking cancelled successfully!');
  
              // Step 3: Send email with 'CANCELLED BOOKING' status
              // sendEmail( bookingData, 'CANCELLED BOOKING' );
  
              navigate('/');
            })
            .catch((error) => {
              alert('Failed to cancel booking: ' + error.message);
            });
        } else {
          alert('Booking not found!');
        }
      })
      .catch((error) => {
        alert('Error fetching booking: ' + error.message);
      });
  };
  

  return (
    <div className="confirmation-container">
      <h2>BOOKING CONFIRMED!</h2>
      {name && startTime && endTime && date? (
        <p><strong>{name}</strong> has successfully booked the slot <strong>{startTime} - {endTime}</strong> on <strong>{date}</strong> in SnookerHut 🎱</p>
      ) : (
        <p>No booking details found.</p>
      )}

      <div className="confirmation-buttons">
        <button onClick={handleEdit}>Edit Booking</button>
        <button onClick={handleCancel} className="cancel">Cancel Booking</button>
        <button onClick={handleHomePage}>Go To Home</button>
      </div>
    </div>
  );
};

export default Confirmation;